const FILL = "#4A9EF7";

export function GoogleIcon() {
  return (
    <svg width="18" height="19" viewBox="0 0 18.1739 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#gg-clip)">
        <path d="M18.1739 9.7105C18.1739 8.93163 18.112 8.36326 17.9782 7.77384H9.2724V11.2893H14.3825C14.2795 12.1629 13.7232 13.4786 12.4868 14.3627L12.4695 14.4804L15.2221 16.6589L15.4128 16.6783C17.1642 15.0258 18.1739 12.5944 18.1739 9.7105" fill={FILL} />
        <path d="M9.2724 18.9729C11.7759 18.9729 13.8776 18.1308 15.4128 16.6783L12.4868 14.3627C11.7038 14.9205 10.6529 15.31 9.2724 15.31C6.82038 15.31 4.73926 13.6575 3.9974 11.3735L3.88866 11.383L1.02646 13.6459L0.989033 13.7522C2.51381 16.8467 5.64583 18.9729 9.2724 18.9729Z" fill={FILL} />
        <path d="M3.9974 11.3735C3.80165 10.7841 3.68836 10.1525 3.68836 9.5C3.68836 8.84739 3.80165 8.21589 3.9871 7.62647L3.98191 7.50094L1.08385 5.20162L0.989033 5.2477C0.360597 6.53181 0 7.97382 0 9.5C0 11.0262 0.360597 12.4681 0.989033 13.7522L3.9974 11.3735" fill={FILL} />
        <path d="M9.2724 3.68996C11.0135 3.68996 12.188 4.45831 12.8577 5.1004L15.4746 2.49009C13.8674 0.963907 11.7759 0.0271429 9.2724 0.0271429C5.64583 0.0271429 2.51381 2.15326 0.989033 5.2477L3.9871 7.62647C4.73926 5.34246 6.82038 3.68996 9.2724 3.68996" fill={FILL} />
      </g>
      <defs>
        <clipPath id="gg-clip">
          <rect width="18.1739" height="19" rx="9.08696" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function EmailIcon() {
  return (
    <svg width="18" height="15" viewBox="0 0 18 14.8235" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.4451 0C14.652 0 15.813 0.436471 16.6671 1.21965C17.5221 2.00118 18 3.05529 18 4.15882V10.6647C18 12.9624 15.957 14.8235 13.4451 14.8235H4.554C2.0421 14.8235 0 12.9624 0 10.6647V4.15882C0 1.86118 2.0331 0 4.554 0H13.4451ZM14.8771 5.38587L14.9491 5.31999C15.1642 5.08117 15.1642 4.73528 14.9392 4.49646C14.8141 4.37375 14.6422 4.29881 14.4631 4.28234C14.2741 4.27328 14.0941 4.33175 13.9582 4.44705L9.90014 7.41176C9.37814 7.80787 8.63024 7.80787 8.10014 7.41176L4.05014 4.44705C3.77024 4.25764 3.38324 4.28234 3.15014 4.5047C2.90714 4.72705 2.88014 5.08117 3.08624 5.32823L3.20414 5.43528L7.29914 8.35881C7.80314 8.72117 8.41424 8.91881 9.05414 8.91881C9.69224 8.91881 10.3141 8.72117 10.8172 8.35881L14.8771 5.38587Z" fill={FILL} />
    </svg>
  );
}

export function AppleIcon() {
  return (
    <svg width="17" height="20" viewBox="0 0 16.5259 19.9341" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.8169 10.534C13.8081 8.90076 14.537 7.668 16.0122 6.76012C15.1868 5.56297 13.9399 4.90432 12.2934 4.77526C10.7348 4.65065 9.03127 5.69648 8.40782 5.69648C7.74925 5.69648 6.23891 4.81976 5.05347 4.81976C2.60357 4.85981 0 6.80018 0 10.7477C0 11.9137 0.210744 13.1182 0.632233 14.3614C1.19422 15.9947 3.22263 20 5.33886 19.9332C6.44527 19.9065 7.22678 19.1366 8.66686 19.1366C10.063 19.1366 10.7875 19.9332 12.0212 19.9332C14.155 19.9021 15.9902 16.2617 16.5259 14.6239C13.6633 13.2577 13.8169 10.6186 13.8169 10.534ZM11.3319 3.22652C12.5305 1.7846 12.4207 0.47174 12.3856 0C11.3275 0.0623053 10.1026 0.729862 9.40447 1.55318C8.63613 2.43436 8.18391 3.5247 8.2805 4.753C9.42642 4.84201 10.4714 4.24566 11.3319 3.22652Z" fill={FILL} />
    </svg>
  );
}

export function PhoneOutlineIcon({ color = "currentColor" }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M15.5599 13.8795L13.8932 12.2128C13.2985 11.6181 12.2867 11.8562 12.0486 12.6295C11.8701 13.1652 11.2754 13.4628 10.7397 13.3438C9.54981 13.0462 7.94266 11.4985 7.64504 10.2491C7.4665 9.71337 7.82357 9.11813 8.35928 8.93959C9.13258 8.70151 9.37066 7.68966 8.77543 7.09444L7.10872 5.42774C6.63255 5.01107 5.91831 5.01107 5.50163 5.42774L4.37118 6.5582C3.24072 7.74812 4.49022 10.9037 7.28884 13.7009C10.0869 16.499 13.2425 17.8085 14.4329 16.6186L15.5599 15.4916C15.9766 15.0154 15.9766 14.2965 15.5599 13.8795Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function GoogleMonochromeIcon({ color = "currentColor" }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M18.28 10.23C18.28 9.55 18.22 9.1 18.09 8.62H10.2V11.61H14.83C14.73 12.35 14.22 13.47 13.1 14.23L15.72 16.26C17.28 14.81 18.28 12.67 18.28 10.23Z"
        fill={color}
      />
      <path
        d="M10.2 18.2C12.47 18.2 14.36 17.45 15.72 16.26L13.1 14.23C12.39 14.72 11.43 15.06 10.2 15.06C7.98 15.06 6.09 13.61 5.43 11.59L2.72 13.67C4.07 16.41 6.89 18.2 10.2 18.2Z"
        fill={color}
      />
      <path
        d="M5.43 11.59C5.25 11.05 5.15 10.49 5.15 9.91C5.15 9.34 5.25 8.78 5.42 8.24L2.72 6.15C2.15 7.3 1.82 8.59 1.82 9.91C1.82 11.24 2.15 12.52 2.72 13.67L5.43 11.59Z"
        fill={color}
      />
      <path
        d="M10.2 4.77C11.78 4.77 12.85 5.45 13.46 6.03L15.79 3.74C14.35 2.37 12.47 1.53 10.2 1.53C6.89 1.53 4.07 3.32 2.72 6.15L5.42 8.24C6.1 6.21 7.98 4.77 10.2 4.77Z"
        fill={color}
      />
    </svg>
  );
}

export function AppleMonochromeIcon({ color = "currentColor" }) {
  return (
    <svg width="20" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        d="M14.2 10.57C14.19 9.09 14.85 7.96 16.2 7.14C15.46 6.06 14.33 5.47 12.85 5.35C11.45 5.23 9.91 6.18 9.35 6.18C8.76 6.18 7.39 5.39 6.33 5.39C4.14 5.43 1.82 7.19 1.82 10.75C1.82 11.79 2.01 12.88 2.39 14C2.89 15.48 4.7 19.08 6.6 19.02C7.59 18.99 8.29 18.29 9.58 18.29C10.83 18.29 11.48 19.02 12.58 19.02C14.5 18.99 16.14 15.69 16.63 14.22C14.06 13 14.2 10.65 14.2 10.57ZM11.97 3.95C13.05 2.65 12.95 1.47 12.92 1.05C11.97 1.1 10.87 1.69 10.24 2.43C9.55 3.22 9.15 4.2 9.23 5.3C10.27 5.38 11.2 4.84 11.97 3.95Z"
        fill={color}
      />
    </svg>
  );
}
